import { Nationality } from "@/types/QuestionPayloadType";

export const sortNationalitiesAlphabetically = (
  allNationalityList: Nationality[]
): Nationality[] => {
  if (!Array.isArray(allNationalityList)) return [];
  return [...allNationalityList].sort((a, b) => a.name.localeCompare(b.name));
};

export const getNationalityPopularCountryList = (
  nationalityPopularCountryListData:
    | Record<string, { countryName?: string }>
    | null
    | undefined
): string[] => {
  if (nationalityPopularCountryListData) {
    return Object.values(nationalityPopularCountryListData)
      .map((item) => item?.countryName)
      .filter((name): name is string => Boolean(name));
  }
  return [];
};

export const reorderNationalities = (
  allNationalityList: Nationality[],
  popularCountries: string[]
): Nationality[] => {
  if (!Array.isArray(allNationalityList)) return [];

  const sortedNationalities =
    sortNationalitiesAlphabetically(allNationalityList);

  const nationalityMap = new Map(
    sortedNationalities.map((item) => [item.name, item])
  );

  const updatedPopularCountries = popularCountries
    .map((name) => nationalityMap.get(name))
    .filter((item): item is Nationality => Boolean(item));

  const updatedAllNationalities = sortedNationalities.filter(
    (item) => !popularCountries.includes(item.name)
  );

  return [...updatedPopularCountries, ...updatedAllNationalities];
};
